import React from 'react'
import './PandaSign.scss'

type Props = {
  children?: React.ReactNode
  size?: number
  signKey?: React.Key
  className?: string
}

const c = 'panda-sign'

export const PandaHead = () => (
  <svg className={`${c}__head`} viewBox='0 0 120 92' aria-hidden>
    <g className={`${c}__ears`}>
      <circle cx='24' cy='24' r='15' />
      <circle cx='96' cy='24' r='15' />
    </g>
    <ellipse className={`${c}__face`} cx='60' cy='54' rx='45' ry='38' />
    <ellipse className={`${c}__patch`} cx='39' cy='51' rx='11' ry='14.5' transform='rotate(28 39 51)' />
    <ellipse className={`${c}__patch`} cx='81' cy='51' rx='11' ry='14.5' transform='rotate(-28 81 51)' />
    <g className={`${c}__eyes`}>
      <circle cx='41' cy='49' r='4.6' fill='#fff' />
      <circle cx='79' cy='49' r='4.6' fill='#fff' />
      <circle cx='42' cy='50' r='2.6' />
      <circle cx='80' cy='50' r='2.6' />
    </g>
    <ellipse className={`${c}__blush`} cx='26' cy='66' rx='7' ry='4' />
    <ellipse className={`${c}__blush`} cx='94' cy='66' rx='7' ry='4' />
    <path className={`${c}__nose`} d='M55 61.5c0-2 10-2 10 0 0 2.4-3 4.5-5 4.5s-5-2.1-5-4.5z' />
    <path className={`${c}__mouth`} d='M60 66v2.5m-6 0c2 3 5 3 6 0 1 3 4 3 6 0' />
  </svg>
)

export const PandaSign = ({ children, size = 88, signKey, className = '' }: Props) => (
  <div
    className={`${c}${children ? '' : ` ${c}--peek`} ${className}`}
    style={{ '--panda-size': `${size}px` } as React.CSSProperties}
  >
    <PandaHead />
    <div className={`${c}__hold`}>
      {children && (
        <div key={signKey} className={`${c}__board`}>
          {children}
        </div>
      )}
      <span className={`${c}__paw ${c}__paw--left`} />
      <span className={`${c}__paw ${c}__paw--right`} />
    </div>
  </div>
)
